import { render, staticRenderFns } from "./AccessControlLayerPopup.vue?vue&type=template&id=daafa620&scoped=true&"
import script from "./AccessControlLayerPopup.vue?vue&type=script&lang=ts&"
export * from "./AccessControlLayerPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daafa620",
  null
  
)

export default component.exports